import { Check, Plus, RotateCcw } from "lucide-react";

import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect.jsx";
import CustomButton from "@/components/desktop/button/CustomButton.jsx";
import CustomTooltip from "@/components/desktop/tooltip/CustomTooltip.jsx";

import styles from "./PendingProductReview.module.scss";

const ConfirmNewProduct = ({
	reviewed,
	localProduct,
	cancelProduct,
	handleConfirmProduct,
	allAptitudesLocal,
	allActiveIngredientsLocal,
	setLocalProduct,
	setAllAptitudesLocal,
	setAllActiveIngredientsLocal,
	products,
}) => {
	const handleCancel = () => {
		let product = { ...localProduct };
		product.label = product.base_text;
		product.value = product.base_value;
		product.reviewed = false;
		product.product_id = null;
		product.aptitudes = [];
		product.active_ingredients = [];
		setLocalProduct(product);
	};

	return (
		<div className={styles.confirmSection}>
			<div className={styles.divider}>
				<div>
					{!reviewed ? (
						<div>
							<span className={styles.strongWarning}>Estás a punto de crear un producto nuevo</span>
							<p>Por favor revisa cuidadosamente los productos sugeridos antes de continuar.</p>
						</div>
					) : (
						<div>
							<span>¿Todo listo?</span>
							<p>Puedes confirmar para finalizar esta revisión.</p>
						</div>
					)}
				</div>

				<div className={styles.divider_content}>
					<CustomTooltip
						text={
							<CustomButton
								className={styles.cancelButton}
								disabled={!localProduct.product_id && localProduct.label === localProduct.base_text}
								onClick={() => handleCancel()}
							>
								<RotateCcw size={15} />
							</CustomButton>
						}
						description="Cancelar selección"
						position="top"
					/>

					<div>
						<CustomInputSelect
							creatable
							value={products.find((p) => p.value === localProduct.value)?.label ?? localProduct.label}
							placeholder="Nombre"
							async={true}
							loadOptions={async (inputValue) => {
								if (!inputValue || inputValue.length < 3) return [];
								return new Promise((resolve) => {
									setTimeout(() => {
										const filtered = products.filter((p) => p.label.toLowerCase().includes(inputValue.toLowerCase()));
										resolve(filtered);
									}, 100);
								});
							}}
							onInputChange={(text) => {
								let newProduct = { ...localProduct };
								newProduct.text_product = text;
								setLocalProduct(newProduct);
							}}
							onChange={(value) => {
								const selectedProduct = products.find((p) => p.value === value);
								if (selectedProduct) {
									let newProduct = { ...localProduct };
									newProduct.product_id = selectedProduct.value;
									newProduct.text_product = selectedProduct.label;
									newProduct.value = selectedProduct.value;
									newProduct.label = selectedProduct.label;
									newProduct.reviewed = true;
									newProduct.aptitudes = selectedProduct.aptitudes_ids;
									newProduct.active_ingredients = selectedProduct.active_ingredients_ids;
									setLocalProduct(newProduct);
								}
							}}
							onCreateOption={(value) => {
								let newProduct = { ...localProduct };
								newProduct.aptitudes = [];
								newProduct.active_ingredients = [];
								newProduct.label = value;
								newProduct.value = value;
								newProduct.product_id = null;
								newProduct.reviewed = false;
								setLocalProduct(newProduct);
							}}
						/>
					</div>

					<div>
						<CustomInputSelect
							isMulti
							creatable
							value={localProduct.aptitudes}
							placeholder="Aptitud"
							async={true}
							options={allAptitudesLocal}
							onInputChange={(text) => {
								let newProduct = { ...localProduct };
								newProduct.text_aptitude = text;
								setLocalProduct(newProduct);
							}}
							onChange={(opt) => {
								let newProduct = { ...localProduct };
								newProduct.aptitudes = opt || [];
								setLocalProduct(newProduct);
							}}
							onCreateOption={(value) => {
								const newOption = { value, label: value };
								let newProduct = { ...localProduct };
								newProduct.aptitudes = [...(newProduct.aptitudes || []), value];
								setLocalProduct(newProduct);

								let newAptitudes = [...allAptitudesLocal];
								newAptitudes.push(newOption);
								setAllAptitudesLocal(newAptitudes);
							}}
						/>
					</div>

					<div>
						<CustomInputSelect
							isMulti
							creatable
							value={localProduct.active_ingredients}
							placeholder="Ingrediente activo"
							options={allActiveIngredientsLocal}
							onInputChange={(text) => {
								let newProduct = { ...localProduct };
								newProduct.text_ingredient = text;
								setLocalProduct(newProduct);
							}}
							onChange={(opt) => {
								let newProduct = { ...localProduct };
								newProduct.active_ingredients = opt || [];
								setLocalProduct(newProduct);
							}}
							onCreateOption={(value) => {
								const newOption = { value, label: value };
								let newProduct = { ...localProduct };
								newProduct.active_ingredients = [...(newProduct.active_ingredients || []), value];
								setLocalProduct(newProduct);

								let newActiveIngredients = [...allActiveIngredientsLocal];
								newActiveIngredients.push(newOption);
								setAllActiveIngredientsLocal(newActiveIngredients);
							}}
						/>
					</div>

					<div>
						<button className={`${styles.confirmBtn} ${reviewed && styles.reviewed}`} onClick={handleConfirmProduct}>
							{reviewed ? <Check size={14} /> : <Plus size={14} />}
							{`Confirmar ${!reviewed ? "como nuevo" : ""} producto`}
						</button>
						<span
							style={{
								display: "none",
								color: "#6c757d",
								cursor: "pointer",
								textDecoration: "underline",
								fontSize: "0.95em",
								textAlign: "right",
								marginTop: "4px",
							}}
							onClick={() => cancelProduct()}
						>
							Cancelar
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConfirmNewProduct;
